module.exports = __webpack_public_path__ + "static/CFG_Artist_SouthCentral-2c3006216e1fa84a1e1f182a92649570.jpg";